import * as React from 'react';
import { connect } from 'react-redux';
import { flow, forEach, get, find} from 'lodash';
import { FormattedNumber } from 'react-intl';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import * as Commonmark from 'react-commonmark';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm, submit } from 'redux-form';
import {
  isRequired, isNotFalse,
  isPostcode, isEmail, isPhone,
} from '../../../../util/validators';
import { IChannel, ICustomer, IPaymentInfo, IPremium, IProduct, ITraveller } from '../../../../data/api/models';
import { IStore } from '../../../../redux/IStore';
import { actions } from '../../../../services/quote/reducer';
import { IQuoteState } from '../../../../services/quote/models';
import Travellers from '../TripDetails/components/Travellers';
import FieldFormControl from '../../../../components/FieldFormControl';
import MarketingOptions from '../../components/MarketingOptions';
import CovidStatement from '../TripDetails/components/CovidStatement';
// tslint:disable-next-line:no-duplicate-imports
import { IPostcodeAddress } from '../../../../data/api/models';
import PostcodeControl from '../../../../components/PostcodeControl';

interface IPaymentFormProps extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  onBack: () => void;
  premium: IPremium;
  renderDefinition(name: string): any;
  channel: IChannel;
  branding: IBrandingState;
  customer: ICustomer;
  purchaseDeclaration: boolean;
  quote: IQuoteState;
  groupType: string;
  password: string;
  passwordConfirmation: string;
  policyDeclaration: boolean;
  errorMessage: string;
  paymentInfo: IPaymentInfo;
  actions: {
    submit(name: string);
    push: (route: string) => void;
    calculate: any;
  };
}

const SIGNPOST_DECLARATION = 'This price includes cover for declared medical condition/s.  ' +
    'As your quote includes a high additional medical premium for one or more of you please read the ' +
    'IMPORTANT INFORMATION';

class PaymentForm extends React.Component<IPaymentFormProps> {
  public state = {
    showCardDetails: true,
  };

  public componentDidMount() {
    if (! window) {
      return;
    }

    const { change } = this.props;
    change('reuseCustomerAddress', false);
    // window.cseInstance = window.adyen.createEncryption();
  }

  public renderPersonalDetails = (leadTraveller: ITraveller) => {
    const { i18n } = this.props;

    const address = [
      leadTraveller.address.line1,
      leadTraveller.address.line2,
      leadTraveller.address.line3,
      leadTraveller.address.town,
      leadTraveller.address.country,
    ]
      .filter((value) => !!value)
      .join(', ');

    return (
      <div>
        <div className="section-title">
          <h2>Personal Details</h2>
        </div>

        <div className="section-group">
          <div className="section">
            <Row>
              <Col sm={4}>
                {i18n.quote.tripDetails.traveller.name}
              </Col>
              <Col sm={8}>
                <div className="quote-info sessioncamhidetext">
                  {leadTraveller.title}{' '}{leadTraveller.firstName}{' '}{leadTraveller.lastName}
                </div>
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <Col sm={4}>
                {i18n.quote.tripDetails.traveller.dob}
              </Col>
              <Col sm={8}>
                <div className="quote-info sessioncamhidetext">
                  {leadTraveller.dob}
                </div>
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <Col sm={4}>
                {i18n.quote.tripDetails.traveller.address}
              </Col>
              <Col sm={8}>
                <div className="quote-info sessioncamhidetext">
                  {address}
                </div>
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <Col sm={4}>
                {i18n.quote.tripDetails.traveller.email}
              </Col>
              <Col sm={8}>
                <div className="quote-info sessioncamhidetext">
                  {leadTraveller.email}
                </div>
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <Col sm={4}>
                {i18n.quote.tripDetails.traveller.phone}
              </Col>
              <Col sm={8}>
                <div className="quote-info sessioncamhidetext">
                  {leadTraveller.phone}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

  public renderTravellersForInput = () => {
    const { i18n, product, groupType, renderDefinition, change } = this.props;

    return (
      <div>
        <div className="section-title">
          <h1>Traveller Details</h1>
        </div>
        <FieldArray
          name="travellers"
          i18n={i18n}
          product={product}
          component={Travellers}
          groupType={groupType}
          renderDefinition={renderDefinition}
          change={change}
        />
      </div>
    );
  }

  private renderTrackingItems = () => {
    const { branding, premium } = this.props;

    const items = [];

    if (branding.channel.channelType === 'AGG' && branding.aggregatorTracking.type === 'cyti' && premium) {
      const params = branding.aggregatorTracking.cyti;
      const cytiUrl = params.url + '/track/click';

      items.push(
        <img
          key={0}
          src={`${cytiUrl}?cref=${params.cref}&premium=${premium.gross}&t=${params.token}`}
          height="0"
          width="0"
        />,
      );
    }

    return items;
  }

  private renderPremium = () => {
    const { quote, schemeId } = this.props;

    let premium: IPremium = null;

    forEach(quote.quotes, (tripTypes) => {
      forEach(tripTypes, (quotedPremium) => {
        if (quotedPremium.scheme.id === schemeId) {
          premium = quotedPremium;
        }
      });
    });
    if (! premium) {
      return null;
    }

    return (
      <FormattedNumber
        value={premium.gross}
        style="currency"
        currency={premium.currency}
      />
    );
  }

  public renderPaymentForm = () => {
    const { product, channel, quote } = this.props;
    const declaration = get(product, 'metadata.purchase_declaration.callcenter.main');
    const hasSignpostedPremiums = quote.application.signposted === 'medical_premiums_b2c';
    const signpostedDeclaration = hasSignpostedPremiums ? `${declaration}\n- ${SIGNPOST_DECLARATION}` : declaration;
    const TERMS_OF_BUSINESS = 'Terms of Business';
    const aiosDocument = find(channel.productDocuments, (document) => {
      return document.shortName === TERMS_OF_BUSINESS;
    });
    const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';
    const covidMessage = get(product.metadata, 'covid_message.payment_b2c', '');
    let privacyUrl = '/privacy-cookies';
    if ('fps-b2c' === channel.key) {
      privacyUrl = 'https://fpstravelcover.org.uk/privacy-cookies/';
    }
    if ('npo-b2c' === channel.key) {
      privacyUrl = 'https://www.narpotravelcover.org.uk/privacy-cookies/';
    }
    if ('cspa-b2c' === channel.key) {
      privacyUrl = get(channel, 'urls.privacyCookies', '');
    }
    if ('css-b2c' === channel.key) {
      privacyUrl = 'https://combinedservicestravelcover.org.uk/privacy-cookies/';
    }
    if ('cssr-b2c' === channel.key) {
      privacyUrl = 'https://combinedservicestravelcover.org.uk/privacy-cookies/';
    }

    return (
      <div>
        <div className="section-title">
          <h1>Payment</h1>
        </div>
          <Row>
              <Col sm={12}>
                  <CovidStatement covidMessage={covidMessage}/>
              </Col>
          </Row>
        <div className="section">
          <Row>
            <div className="internal-title">Declaration</div>
            I declare:
              <Commonmark
                className="payment-links"
                source={signpostedDeclaration}
                linkTarget="_blank"
                transformLinkUri={this.transformLinks('policy_wording')}
              />
            {channel.key === 'fps-b2c' && (
              <Commonmark
                  className="payment-links"
                  source={'If you do not wish to renew your insurance with us, or if at any point during the ' +
                      'period of ' +
                  'insurance you wish to opt out of the auto renewal process, please contact the Scheme ' +
                      'Administrator,' +
                  ' FPS on 02392 419 856 or submit a message [here](https://fpstravelcover.org.uk/#contact)'}
                  linkTarget="_blank"
                  transformLinkUri={this.transformLinks('here')}
              />
            )}
            <Row className="radio-horizontal payment-declaration-container">
              <Col xs={10} sm={7}>
                <Field
                  name="policyDeclaration"
                  type="checkbox"
                  label={}
                  component={FieldFormControl}
                  validate={[
                    isRequired,
                    isNotFalse,
                  ]}
                >
                  I agree with the above Declaration
                  <div />
                </Field>
              </Col>
            </Row>
          </Row>
        </div>
        <div className="section">
          <Row className="payment-links">
            For more information about our service to you and how we will use your information, please read our
            <a
                href={aboutUsUrl}
                target="_blank"
            > <strong>Terms of Business</strong>
            </a> and our <a
              href={privacyUrl}
              target="_blank"
            >
            <strong>Privacy Policy.</strong>
          </a>
          </Row>
        </div>
        <div className="section">
          <Row>
            <div className="internal-title">Payment Details</div>
            <div style={{ marginTop: '5px' }}>
              Total amount to pay: <strong>{this.renderPremium()}</strong>
            </div>
            <small>
              (inc. Insurance Premium Tax (IPT) if applicable)
            </small>
            {channel.key === 'cspa-b2c' ? (
                <div className="margin-top">
                  Once you are sure all your details are correct and the cover meets your needs, select the
                  BUY NOW option and you will be prompted to enter your card details.
                </div>
            ) : (
                <div className="margin-top">
                  Once you are sure all your details are correct and the cover meets your needs,
                  enter your card details and click 'BUY NOW'.
                </div>
            )}

            {/*<div className="margin-top">*/}
              {/*Our site is secured by GeoTrust which means that your payment card details will be safe and secure.*/}
            {/*</div>*/}
            <div className="margin-top">
              If you have any issues trying to purchase your policy,
              please call us on {channel.phone} (we are open {channel.openingHours}, closed bank
              holidays).
            </div>
          </Row>
        </div>
      </div>
    );
  }

  public renderPaymentBillingData = () => {
    const { i18n } = this.props;

    return (
      <>
        <div className="payment-details-chk">
          <Row className="radio-horizontal">
            <Col sm={12}>
              <Field
                  name="reuseCustomerAddress"
                  type="checkbox"
                  component={FieldFormControl}
                  onChange={this.handleOnChange}
                  validate={[
                      isRequired,
                  ]}
              >
                <div/>
                Are card holder details same as yours?
              </Field>
            </Col>
          </Row>
        </div>

        {this.state.showCardDetails ? (
            <>
              <div className="margin-top">
                <Row>
                  <Col sm={4}>
                    Card Holder name
                  </Col>
                  <Col sm={4}>
                    <Field
                        name="payment.billing.name"
                        type="text"
                        placeholder="Cardholder name"
                        component={FieldFormControl}
                        validate={[isRequired]}
                        className="payment-field"
                    />
                  </Col>
                </Row>
              </div>
              <div className="margin-top">
                <Row>
                  <Col sm={4}>
                    Card Holder Email
                  </Col>
                  <Col sm={4}>
                    <Field
                        name="payment.billing.email"
                        type="text"
                        placeholder="Cardholder Email"
                        component={FieldFormControl}
                        validate={[isRequired, isEmail]}
                        className="payment-field"
                    />
                  </Col>
                </Row>
              </div>
              <div className="margin-top">
                <Row>
                  <Col sm={4}>
                    Card Holder Phone
                  </Col>
                  <Col sm={4}>
                    <Field
                        name="payment.billing.phone"
                        type="text"
                        placeholder="Cardholder Phone"
                        component={FieldFormControl}
                        validate={[isRequired, isPhone]}
                        className="payment-field"
                    />
                  </Col>
                </Row>
              </div>
              <div className="margin-top">
                <Row>
                  <Col sm={4}>
                    Card Holder Postcode
                  </Col>
                  <Col sm={4}>
                    <Field
                        name="payment.billing.address.postcode"
                        type="text"
                        placeholder={get(i18n, 'quote.tripDetails.traveller.postcode',
                            'Postcode')}
                        component={PostcodeControl}
                        onSelectAddress={this.handleSelectCardHolderAddress}
                        validate={[
                          isRequired,
                          isPostcode,
                        ]}
                    />
                  </Col>
                </Row>
              </div>
              <div className="margin-top">
                <Row>
                  <Col sm={6}>
                    <label>{get(i18n, 'quote.tripDetails.traveller.address', 'Card Holder Address')}</label>
                  </Col>
                </Row>
              </div>
              <div className="margin-top">
                <Row>
                  <Col sm={4}/>
                  <Col sm={4}>
                    <Field
                        className="line-top"
                        name="payment.billing.address.line1"
                        placeholder="Line 1"
                        type="text"
                        component={FieldFormControl}
                        validate={[
                          isRequired,
                        ]}
                    />
                    <Field
                        className="line-middle"
                        name="payment.billing.address.line2"
                        placeholder="Line 2"
                        type="text"
                        component={FieldFormControl}
                    />
                    <Field
                        className="line-middle"
                        name="payment.billing.address.town"
                        type="text"
                        placeholder="Town"
                        component={FieldFormControl}
                    />
                    <Field
                        className="line-bottom payment-field"
                        name="payment.billing.address.county"
                        placeholder="County"
                        type="text"
                        component={FieldFormControl}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}><hr /></Col>
                </Row>
              </div>
            </>
        ) : (
          <hr />
        )}
      </>
    );
  }

  private handleSelectCardHolderAddress = (address: IPostcodeAddress) => {
    const { change } = this.props;
    const base = 'payment.billing.address';

    change(`${base}.line1`, address.line1);
    change(`${base}.line2`, address.line2);
    change(`${base}.town`, address.town);
    change(`${base}.county`, address.county);
    change(`${base}.postcode`, address.postcode);
  }

  private handleOnChange = (data, value) => {
    this.setState({showCardDetails: !value});
  }

  public render() {
    const {
      product,
      submitting,
      handleSubmit,
      valid,
      submitFailed,
      quote,
      password,
      passwordConfirmation,
      policyDeclaration,
      errorMessage,
      channel,
      onBack,
      schemeId,
    } = this.props;

    const isAgg = channel.channelType === 'AGG';
    const leadTraveller = quote.application.travellers[0];
    const customer = quote.customer;

    const hasCustomer = !! customer;
    const disableSubmit = customer.status === 'new' && password !== passwordConfirmation;

    const formHasError = isRequired && submitFailed && !valid;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          {isAgg && this.renderTravellersForInput()}
          {this.renderTrackingItems()}
          {this.renderPaymentForm()}
          {quote.errorMessage && (
            <Alert bsStyle={'danger'} style={{color: '#d64f48', marginBottom: 10}}>
              {errorMessage}
            </Alert>
          )}
          {this.renderPaymentBillingData()}
          {isAgg && (
            <div className="section">
              <Row>
                <MarketingOptions/>
              </Row>
            </div>
          )}
          <hr/>
          <div className="btn-bar">
            <Button
              bsStyle="primary"
              type="submit"
              className="pull-right btn-remove-border"
              disabled={
                submitting ||
                (submitFailed && !valid) ||
                !policyDeclaration ||
                disableSubmit ||
                !hasCustomer
              }
            >
              Buy Now
            </Button>

            {! isAgg && (
              <Button type="button" className="btn-back" onClick={onBack}>
                Back
              </Button>
            )}
          </div>
        </div>
      </Form>
    );
  }

  private handlePayViaAccount = () => {
    const { change, handleSubmit } = this.props;

    change('payOnAccount', true);

    setTimeout(handleSubmit, 200);
  }

  private renderCommonmark = (value, key) => {
    return (
      <div key={key}>
        <Commonmark
          source={value}
          linkTarget="_blank"
          transformLinkUri={this.transformLinks('policy_wording')}
        />
      </div>
    );
  }

  private transformLinks = (url) => () => {
    const { premium, channel } = this.props;

    if (url === 'here') {
      return 'https://fpstravelcover.org.uk/#contact';
    }

    if (url === 'policy_wording' || url === 'Insurance Policy') {
      const pwDocument = find(channel.productDocuments, (document) => {
        return document.shortName === 'Evidence of Cover';
      });

      if (pwDocument) {
        return pwDocument.filePath;
      }
    }

    if (url === 'policy_summary') {
      return premium.scheme.documents[ 'Policy Summary' ];
    }

    if (url === 'tobca') {
      return premium.scheme.documents[ 'Terms of Business Customer Agreement' ];
    }

    return url;
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Your confirmed password doesn\'t match the first field, please enter them again.';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const channel = state.branding.channel;
      const quotes = state.quote.quotes;
      const errorMessage = state.quote.errorMessage;
      const schemeId = selector(state, 'schemeId');
      const password = selector(state, 'password');
      const passwordConfirmation = selector(state, 'passwordConfirmation');
      const policyDeclaration = selector(state, 'policyDeclaration');
      const paymentInfo = selector(state, 'payment');

      let premium = null;

      forEach(quotes, (tripTypes, level) => {
        forEach(tripTypes, (quotedPremium) => {
          if (quotedPremium.scheme.id === schemeId) {
            premium = quotedPremium;
          }
        });
      });

      return {
        schemeId,
        premium,
        channel,
        policyDeclaration,
        password,
        passwordConfirmation,
        errorMessage,
        paymentInfo,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        submit: bindActionCreators(submit, dispatch),
        calculate: bindActionCreators(actions.calculate, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(PaymentForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Payment/index.tsx